<div class="relative p-4 flex flex-col gap-4">
  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Coordonnées de la banque</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right whitespace-nowrap">Enseigne</td>
        <td>
          <select-type-banque
            [(ngModel)]="banque.typeBanque_ID"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-type-banque>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Lieu / Nom</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="banque.banque_Lieu"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Code guichet</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="5"
              [(ngModel)]="banque.banque_Guichet"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Adresse</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="banque.banque_Adresse1"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Complément</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="banque.banque_Adresse2"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">CP, Ville</td>
        <td class="flex gap-1">
          <mat-form-field appearance="outline" class="w-20">
            <input
              matInput
              [maxlengthinput]="6"
              [(ngModel)]="banque.banque_CP"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="banque.banque_Ville"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Pays</td>
        <td>
          <select-pays
            [(ngModel)]="banque.pays_ID"
            [selectNo]="true"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-pays>
        </td>
      </tr>
    </table>
  </mat-card>

  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Communications de la banque</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right items-start">Tél, Fax</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="banque.banque_Tel"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="banque.banque_Fax"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right items-start">Contact 1, Tél</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="banque.banque_Contact1"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="banque.banque_Tel1"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right items-start">Contact 2, Tél</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="banque.banque_Contact2"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="banque.banque_Tel2"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Email</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="banque.banque_Email"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
  </mat-card>
</div>
